import { render, staticRenderFns } from "./client-dialog-switch-off-times-tab.vue?vue&type=template&id=25df65e9"
import script from "./client-dialog-switch-off-times-tab.vue?vue&type=script&lang=js"
export * from "./client-dialog-switch-off-times-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports